<div class="permission-display" *ngIf="isActive">
  <div class="permission-content" (click)="toggleExpansion()">
    <span class="permission-name">{{ label }}</span>
    <div class="permission-details">
      <span class="scope-count" *ngIf="getScopeCount() > 0">({{ getScopeCount() }} {{ (getScopeCount() > 1 ?
        'access_control.form.banner.scope_count_plural' : 'access_control.form.banner.scope_count') | translate
        }})</span>
      <div class="chevron-icon" [class.expanded]="isExpanded">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  </div>

  <div class="scope-configuration" *ngIf="isExpanded" [formGroup]="permissionsForm">
    <div class="scope-header">
      <h3>{{ 'access_control.form.banner.resource_scopes' | translate }}</h3>
      <button type="button" class="bciti-button bciti-button--small" (click)="addScope()">
        {{ 'access_control.form.banner.add_scope' | translate }}
      </button>
    </div>

    <div class="scopes-list" formArrayName="scopes">
      <div *ngIf="scopes && scopes.length === 0" class="no-scopes">
        {{ 'access_control.form.banner.no_scopes' | translate }}
      </div>

      <div *ngFor="let scope of scopes.controls; let i = index" class="scope-item" [formGroupName]="i">
        <div class="scope-fields">
          <!-- Resource Type Field - Dropdown or Input -->
          <div class="field-group">
            <label>{{ 'access_control.form.banner.resource_type.label' | translate }}</label>

            <select *ngIf="usesDropdowns" formControlName="resource" (change)="onResourceChange(scope, i)">
              <option *ngIf="!usesDropdowns" value="">{{ 'access_control.form.banner.resource_type.placeholder' | translate }}</option>
              <option *ngFor="let option of resourceOptions$ | async" [value]="option.value">
                {{ option.labelKey | translate }}
              </option>
            </select>

            <input *ngIf="!usesDropdowns" type="text" formControlName="resource"
              [placeholder]="'access_control.form.banner.resource_type.placeholder' | translate" />
          </div>

          <!-- Resource ID Field - Dropdown or Input -->
          <div class="field-group">
            <label>{{ 'access_control.form.banner.resource_id.label' | translate }}</label>

            <ng-container *ngIf="usesDropdowns && (getResourceIdOptions(i) | async) as options">
              <select formControlName="resourceId" [disabled]="!scope.get('resource')?.value || options.length <= 1">
                <option *ngIf="!usesDropdowns" value="">{{ 'access_control.form.banner.resource_id.placeholder' | translate }}</option>
                <option *ngFor="let option of options" [value]="option.value">
                  {{ option.labelKey | translate }}
                </option>
              </select>
            </ng-container>

            <input *ngIf="!usesDropdowns" type="text" formControlName="resourceId"
              [placeholder]="'access_control.form.banner.resource_id.placeholder' | translate" />
          </div>

          <!-- Access Level Field - Always a Dropdown -->
          <div class="field-group">
            <label>{{ 'access_control.form.banner.access_level.label' | translate }}</label>
            <select formControlName="accessLevel">
              <option value="read">{{ 'access_control.form.banner.access_level.read' | translate }}</option>
              <option value="write">{{ 'access_control.form.banner.access_level.write' | translate }}</option>
            </select>
          </div>

          <div class="field-actions">
            <button type="button" class="remove-scope-btn" (click)="removeScope(i)"
              [title]="'access_control.form.banner.remove_scope' | translate">
              <svg viewBox="0 0 16 16" fill="none">
                <path d="M4 4L12 12M4 12L12 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>